export abstract class AbstractApi {
  protected async get<T>(endpoint: string, apiName: string): Promise<T> {
    const fetchOptions: RequestInit = {
      method: 'GET',
      mode: 'same-origin',
      credentials: 'same-origin',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    if (typeof AbortSignal !== 'undefined' && typeof AbortSignal.timeout === 'function') {
      fetchOptions.signal = AbortSignal.timeout(5000);
    }

    const response = await fetch(endpoint, fetchOptions);

    if (response.status >= 400) {
      throw new Error(`${apiName} API call failed: ${await response.text()}`);
    }

    return response.json();
  }

  async post(endpoint: string, apiName: string, bodyAsJson: object) {
    return this.send(endpoint, 'POST', apiName, bodyAsJson);
  }

  async delete(endpoint: string, apiName: string, bodyAsJson: object) {
    return this.send(endpoint, 'DELETE', apiName, bodyAsJson);
  }

  private async send(endpoint: string, method: 'POST' | 'DELETE' | 'PUT', apiName: string, bodyAsJson: object) {
    try {
      const response = await fetch(endpoint, {
        method: method,
        body: JSON.stringify(bodyAsJson),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.ok;
    } catch (error) {
      console.error(`${apiName} Api call failed:`, error);
      return false;
    }
  }
}
